<template>
  <div class="industry-item">
    <a class="image-wrapper" href="http://www.baidu.com" onclick="return confirm('该文章需要付费5元阅读全文，确定付费?');" >
      <img :src="img.img" :alt="img.title">
    </a>
    <div class="title">
      {{ img.title }}
    </div>
    <div class="content">
      {{ img.content }}
    </div>
    <div class="time">
      付费5元查看
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndustryConsulting',
  props: {
    img: Object,
  },
}
</script>

<style scoped>
.industry-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.time {
  color: #999;
  font-size: 12px;
  font-family: arial;
  margin-top: 10px;
}
.image-wrapper {
  position: relative;
  width: 100%;
  background: transparent;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center; /* 水平居中 */
}

.image-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(128, 128, 128, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.image-wrapper img {
  width: 40%; /* 保持你设置的40%宽度 */
  object-fit: cover;
  position: relative; /* 改为relative以保持垂直位置 */
  z-index: 2;
  transition: all 0.3s ease;
}

.image-wrapper:hover::before {
  opacity: 1;
}

.image-wrapper:hover img {
  transform: scale(1.0); /* 悬停时轻微放大 */
}

.title {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.content {
  color: #666;
}
</style>